<div class="modal-header">
  @if (updateMode) {
    <!--Modal update mode-->
    <h4 class="modal-title update-modal" id="modal-update-title">
      {{ title | translate }}
    </h4>
  } @else {
    <h4 class="modal-title" id="modal-basic-title">
      {{ title | translate }}
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  }
</div>

<div class="modal-body d-flex flex-column">
  <div class="fw-bold message">
    {{ content | translate }}
  </div>

  <!--Historic update modal (no precision on new feature)-->
  <div class="fw-bold message">
    {{ content2 | translate }}
  </div>
</div>

<!--Modal update mode /w snooze-->
<div *ngIf="snooze" class="modal-body explanation">
  <div class="message">
    <span [style.font-style]="'normal'">{{ 'application-update.modal-explanation' | translate }}</span>
  </div>
</div>

<div *ngIf="!updateMode" class="modal-footer">
  <ng-container *ngIf="!alertMode">
    <button type="button" class="cancel fw-bold" (click)="close()">{{ 'button.modal-cancel-no' | translate }}</button>
    <button type="button" class="btn confirm-delete d-flex" (click)="cancelConfirm()">
      <div class="icon icon--trash align-self-center"></div>
      <div class="text-uppercase fw-bold align-self-center">
        {{ btnName | translate }}
      </div>
    </button>
  </ng-container>
  <ng-container *ngIf="alertMode">
    <button type="button" class="btn confirm-delete d-flex" (click)="close()">
      <div class="text-uppercase fw-bold align-self-center">
        {{ btnName | translate }}
      </div>
    </button>
  </ng-container>
</div>

<!--Modal update mode /w and w/o snooze-->
<div *ngIf="updateMode" class="modal-footer update-modal">
  <ng-container>
    <button *ngIf="snooze" id="{{ snoozeButtonClickedId }}" class="snooze fw-bold" type="button" (click)="snoozeAndClose()">
      {{ 'application-update.modal-snooze' | translate }}
    </button>
    <button type="button" class="btn confirm-delete d-flex" (click)="updateConfirm()">
      <div class="icon icon--refresh align-self-center"></div>
      <div class="text-uppercase fw-bold align-self-center">
        {{ btnName | translate }}
      </div>
    </button>
  </ng-container>
</div>
